

  export default {
    name: 'ImageComponent',

    props: {
        src: {
            type: String,
            default: "",
        },
        alt: {
            type: String,
            default: "",
        },
        width: {
            type: String,
            default: "",
        },
        height: {
            type: String,
            default: "",
        },
        
    },

    data() {
      return {
        modeAvailable: ['text-image', 'image-text'],
      }
    },
  }
